import { createFilledIcon } from "../createIcon";

export const ShieldFilledIcon = createFilledIcon(
  <>
    <path d="M12 2.4C9.305 4.693 7.615 4.8 4.8 4.8v9.228c0 3.682 2.563 4.643 7.2 7.572 4.638-2.929 7.2-3.89 7.2-7.572V4.8c-2.812 0-4.502-.107-7.2-2.4Z" />
  </>,
  "ShieldFilledIcon"
);
